import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Input, Select, Divider, Table, Image, Button, Modal, Form, Checkbox, Spin, notification, Progress } from 'antd';
import { PlusOutlined, FileAddOutlined, CloseCircleOutlined, SaveOutlined, SyncOutlined, FileImageOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types'
import { fetchData, sendData } from '../../httpRequests';

const form = {
    name: '',
    category_id: 1,
    description: "",
    upc: "",
    stock: 0,
    price: 0,
    ivu_statal: false,
    ivu_municipal: false,
    gift_status: false,
    gift_price: 0,
    pharmacy_id: Number(localStorage.getItem('PHARMACY_LOGGED')),
    active: false
}

export default function CreateNewProductsByFarmacy({ reloaDataPhather }) {
    const [isModalVisibleCreateProduct, setIsModalVisibleCreateProduc] = useState(false);
    const [seeImgInput, setSeeImgInput] = useState(null);
    const [formValues, setFormValues] = useState(form)
    const [categorys, setCategorys] = useState([]);

    const { name, category_id, description, upc, stock, price, ivu_statal, ivu_municipal, gift_status, gift_price, active } = formValues

    useEffect(() => {
        getCategory()
    }, [])

    useEffect(() => {
        if (seeImgInput != null) {
            seeFileProduct()
        }
    }, [seeImgInput])

    const seeFileProduct = async () => {
        if (seeImgInput.target.files[0] != undefined) {
            const image = document.getElementById("image-selected");
            const reader = new FileReader();
            reader.readAsDataURL(seeImgInput.target.files[0]);
            reader.onload = (seeImgInput) => {
                seeImgInput.preventDefault();
                image.setAttribute('src', seeImgInput.target.result)
            }
        } else {
            setSeeImgInput(null)
        }
    }

    const getCategory = async () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                setCategorys(categories)
            }
        })
    }

    const handleFilter = (e) => {
        // const filteredProducts = products.filter((product) => {
        //     return product.categoryId == e

        // });

        // setFilteredProducts(filteredProducts);
        setFormValues({
            ...formValues,
            category_id: e

        })
    }

    const showModalCreateProduct = () => {
        setIsModalVisibleCreateProduc(true);
    };

    const closeProductModal = () => {
        setIsModalVisibleCreateProduc(false);
    };

    const handleInputChangeCheckbox = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.checked
        });

    }

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }

    const SaveProduct = async () => {
        const url = '/products/createProductByPharmacy';
        sendData(url, formValues).then(async (response) => {
            if (Object.keys(response).length > 0) {
                if (response.ok) {
                    if (seeImgInput != null && seeImgInput != undefined) {
                        await handleFile(response.createProduct.id)
                    }
                    openNotificationWithIcon('success', 'product added successfully')
                    setIsModalVisibleCreateProduc(false);
                    clearForm()
                    reloaDataPhather();
                } else {
                    console.log(response.ok)
                    openNotificationWithIcon('warning', 'Cannot be added.')
                }
            }
        })
    }

    const handleFile = async (id) => {
        let cloudurl = (window.location.hostname.includes('localhost'))
            ? `http://localhost:3003/api/products/updateProductPhoto/${id}`
            : `https://coopharma-api-zd5is.ondigitalocean.app/api/products/updateProductPhoto/${id}`

        let file = seeImgInput.target.files[0]
        const formData = new FormData();
        formData.append('image', file);
        try {
            const resp = await fetch(cloudurl, {
                method: 'post',
                body: formData
            });

            if (resp.ok) {
                const cloudResp = await resp.json();
                setSeeImgInput(null)
            }
        } catch (error) {
            console.log(error, "error")
        }
    }
    const clearForm = () => {
        setFormValues(form)
    }
    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    return (
        <div>
            <Button type='primary' size='large' style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }} onClick={showModalCreateProduct}>
                Create Product
            </Button>

            <Modal title="Create Product" width={700} visible={isModalVisibleCreateProduct} onCancel={closeProductModal} footer={null}>
                <Row gutter={24}>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span> Name</label>
                        <Input
                            size='large'
                            type='text'
                            name="name"
                            value={name}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span> Upc</label>
                        <Input
                            size='large'
                            type='number'
                            name="upc"
                            value={upc}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}> </span>Description</label>
                        <textarea
                            id="w3review"
                            rows="4" cols="70"
                            name="description"
                            value={description}
                            onChange={handleInputChange}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>

                        <label htmlFor=""><span style={{ color: 'red' }}>*</span> Category</label>
                        <Select style={{ width: '100%' }} defaultValue={category_id} size='large' onChange={handleFilter} name="category_id" value={category_id} >
                            {categorys.map((c) => (
                                <Select.Option key={c.id} value={c.id}  >
                                    {c.name}
                                </Select.Option>
                            ))
                            }
                        </Select>
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor="">Quantity</label>
                        <Input
                            size='large'
                            type='number'
                            name="stock"
                            value={stock}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""> Price</label>
                        <Input
                            size='large'
                            type='number'
                            name="price"
                            value={price}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={4} className='formMarginInput'>
                        <Row gutter={24}>
                            <Col span={24}>
                                <label htmlFor=""> State TAX</label>
                            </Col>
                            <Col span={24}>
                                <Checkbox
                                    name="ivu_statal"
                                    checked={ivu_statal}
                                    onChange={handleInputChangeCheckbox}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={5} className='formMarginInput'>
                        <Row gutter={24}>
                            <Col span={24}>
                                <label htmlFor=""> Municipal TAX</label>
                            </Col>
                            <Col span={24}>
                                <Checkbox
                                    size='large'
                                    name="ivu_municipal"
                                    checked={ivu_municipal}
                                    onChange={handleInputChangeCheckbox}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={3} className='formMarginInput'>
                        <Row gutter={24}>
                            <Col span={24}>
                                <label htmlFor="">Gift</label>
                            </Col>
                            <Col span={24}>
                                <Checkbox
                                    size='large'
                                    name="gift_status"
                                    checked={gift_status}
                                    onChange={handleInputChangeCheckbox}

                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor="">Gift Price</label>
                        <Input
                            size='large'
                            type='number'
                            name="gift_price"
                            value={gift_price}
                            onChange={handleInputChange}
                            disabled={gift_status == false}
                        />

                    </Col>
                    <Col span={3} className='formMarginInput'>
                        <Row gutter={24}>
                            <Col span={24}>
                                <label htmlFor="">Active</label>
                            </Col>
                            <Col span={24}>
                                <Checkbox
                                    size='large'
                                    name="active"
                                    checked={active}
                                    onChange={handleInputChangeCheckbox}

                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={16}>
                        <label htmlFor="" >Select Image</label>
                        <div className='bordereFile' style={{ marginTop: "10px" }}>
                            <div className='file-select'>
                                <div className='drag'>
                                    <div>
                                        <div style={{ textAlign: 'center' }}>

                                            <FileImageOutlined style={{ fontSize: '32px', color: 'white' }} />
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <b style={{ fornSize: '17px', color: 'white' }}>Add Image</b>
                                        </div>
                                        <p style={{ color: 'white' }}>or drag and drop</p>
                                    </div>
                                </div>
                                <input type="file" onChange={(e) => setSeeImgInput(e)} accept="image/x-png,image/gif,image/jpeg" />
                            </div>
                        </div>

                    </Col>
                    <Col span={8}>
                        {(seeImgInput != null) ? <img src="" alt="" id="image-selected" height="150px" width="150px" style={{ marginTop: "30px" }} /> : <div><img style={{ marginTop: "30px" }} height="150px" width="150px" src="http://openmart.online/frontend/imgs/no_image.png?" alt="" /></div>}
                    </Col>

                    <Col span={24}>
                        <Button
                            onClick={SaveProduct}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: '15px' }}
                            disabled={name == '' || upc == null || upc == ''}
                        >
                            <SaveOutlined />
                            Save
                        </Button>
                    </Col>

                </Row>


            </Modal>
        </div>
    )

}

CreateNewProductsByFarmacy.propTypes = {
    reloaDataPhather: PropTypes.func
}